import React from "react";
import { Plus, ChevronUp, ChevronDown, RotateCw, FileText, HelpCircle, Flag, Trash2 } from "lucide-react";

const sortByOrder = (arr) => [...(arr || [])].sort((a, b) => a.order - b.order);

const CurriculumTree = ({ formation, selected, onSelect, actions }) => {
  const modules = sortByOrder(formation.FormationModules);
  const quizzes = formation.FormationQuizzes || [];
  const finalQuiz = quizzes.find((q) => !q.moduleId);
  const moduleQuiz = (moduleId) => quizzes.find((q) => q.moduleId === moduleId);

  return (
    <div className="builder-tree">
      <div className="builder-tree-head">
        <span>Curriculum</span>
        <button className="text-btn accent" onClick={actions.addModule}>
          <Plus size={15} /> Module
        </button>
      </div>

      {modules.map((m, mi) => (
        <div className="builder-module" key={m.id}>
          <div className="module-title-row">
            <input
              className="module-title"
              defaultValue={m.title}
              onBlur={(e) => actions.renameModule(m.id, e.target.value)}
            />
            <span className="version-badge">v{m.version}</span>
            <div className="module-actions">
              <button className="ghost-btn" title="Monter" disabled={mi === 0} onClick={() => actions.moveModule(m, -1)}>
                <ChevronUp size={15} />
              </button>
              <button
                className="ghost-btn"
                title="Descendre"
                disabled={mi === modules.length - 1}
                onClick={() => actions.moveModule(m, 1)}
              >
                <ChevronDown size={15} />
              </button>
              <button className="ghost-btn danger" title="Supprimer le module" onClick={() => actions.deleteModule(m)}>
                <Trash2 size={15} />
              </button>
            </div>
          </div>

          <div className="module-toolbar">
            <button className="text-btn" onClick={() => actions.addLesson(m.id)}>
              <Plus size={14} /> Leçon
            </button>
            <button
              className="text-btn accent"
              title="Publier une nouvelle version (les apprenants devront repasser ce module)"
              onClick={() => actions.publishModuleVersion(m)}
            >
              <RotateCw size={14} /> Nouvelle version
            </button>
          </div>

          {sortByOrder(m.FormationLessons).map((l, li, arr) => (
            <div
              key={l.id}
              className={`tree-item ${selected.type === "lesson" && selected.id === l.id ? "selected" : ""}`}
              onClick={() => onSelect("lesson", l.id)}
            >
              <FileText size={15} className="lead" />
              <span className="grow">{l.title}</span>
              <div className="tree-item-actions">
                <button
                  className="ghost-btn"
                  title="Monter"
                  disabled={li === 0}
                  onClick={(e) => {
                    e.stopPropagation();
                    actions.moveLesson(m, l, -1);
                  }}
                >
                  <ChevronUp size={14} />
                </button>
                <button
                  className="ghost-btn"
                  title="Descendre"
                  disabled={li === arr.length - 1}
                  onClick={(e) => {
                    e.stopPropagation();
                    actions.moveLesson(m, l, 1);
                  }}
                >
                  <ChevronDown size={14} />
                </button>
                <button
                  className="ghost-btn danger"
                  title="Supprimer la leçon"
                  onClick={(e) => {
                    e.stopPropagation();
                    actions.deleteLesson(l);
                  }}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}

          {moduleQuiz(m.id) && (
            <div
              className={`tree-item quiz ${
                selected.type === "quiz" && selected.id === moduleQuiz(m.id).id ? "selected" : ""
              }`}
              onClick={() => onSelect("quiz", moduleQuiz(m.id).id)}
            >
              <HelpCircle size={15} className="lead" />
              <span className="grow">Quizz du module</span>
            </div>
          )}
        </div>
      ))}

      {finalQuiz && (
        <div
          className={`tree-item quiz final ${
            selected.type === "quiz" && selected.id === finalQuiz.id ? "selected" : ""
          }`}
          onClick={() => onSelect("quiz", finalQuiz.id)}
        >
          <Flag size={15} className="lead" />
          <span className="grow">Quizz final</span>
        </div>
      )}
    </div>
  );
};

export default CurriculumTree;
